module.exports = __webpack_public_path__ + "img/icon_map_61_on_001.3a30f437.png";